import { Spin } from '@arco-design/web-react';
import classnames from 'classnames';
import { lazy, Suspense } from 'react';
import styles from './index.module.less';

const AceEditor = lazy(() => import(/* webpackChunkName: "react-ace" */ './ace-editor'));

const DEFAULT_SET_OPTIONS = {
  useWorker: false,
  showPrintMargin: false,
} as const;

export interface CodeEditorProps {
  /** 编辑器内容，支持字符串或对象（对象会 JSON 序列化） */
  value?: string | object | string[] | object[];
  /** 语法模式，如 yaml、javascript、json 等 */
  mode?: string;
  /** 透传给 AceEditor 的额外配置 */
  options?: Record<string, unknown>;
  /** 内容变更回调 */
  onChange?: (value: string) => void;
  /** 是否只读 */
  readOnly?: boolean;
  /** 主题，如 chaos、textmate、xcode 等 */
  theme?: string;
  /** 自定义类名 */
  className?: string;
}

function CodeEditor({
  value = '',
  mode = 'javascript',
  options = {},
  onChange,
  readOnly = false,
  theme = 'chaos',
  className,
}: CodeEditorProps) {
  return (
    <Suspense fallback={<Spin className="ks-page-loading" />}>
      <AceEditor
        theme={theme}
        {...options}
        className={classnames(styles.editor, className)}
        value={typeof value === 'string' ? value : value != null ? JSON.stringify(value) : ''}
        mode={mode}
        onChange={onChange}
        readOnly={readOnly}
        setOptions={DEFAULT_SET_OPTIONS}
      />
    </Suspense>
  );
}

export default CodeEditor;
